/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import {
  getInsuranceLoanById,
  updateInsuranceLoan,
  getAllAdmins,
  getAllCities,
  getInsuranceLoanByMobile,
  getAllStates,
  getAllPincode,
  getInsuranceLoanByEmail,
} from "../../../middleware/backend_hepler";
import LabeledInput from "../../../components/LabeledInput";
import LabeledSelect from "../../../components/LabeledSelect";
import LabeledSelectAgent from "../../../components/LabeledSelectAgent";
import LabeledDropDown from "../../../components/LabeledDropDown";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { validationRules } from "../../../utils/validationRules";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../components/Loader";

const EditInsuranceLoan = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [error, setError] = useState(null);
  const [emailExists, setEmailExists] = useState(false);
  const [initialEmail, setInitialEmail] = useState("");
  const [mobileExists, setMobileExists] = useState(false);
  const [initialMobile, setInitialMobile] = useState("");
  const { adminRole, adminName, adminId } = useContext(AuthContext);
  const [status, setStatus] = useState("");
  const [insuranceType, setInsuranceType] = useState("");

  const steps = ["Personal Details", "Loan Details", "Upload Documents"];

  const methods = useForm({
    defaultValues: {
      created_id: "",
      created_by: "",
      assigned_to: "",
      status: "",
      name: "",
      dob: "",
      age: "",
      gender: "",
      mobile1: "",
      mobile2: "",
      email: "",
      company_name: "",
      address_1: "",
      state: "",
      rejected_reason: "",
      employee_type: "",
      city: "",
      pincode: "",
      insurance_type: "",
      patient_marital_status: "",
      health_insurance_coverage_amount: "",
      co_name: "",
      co_dob: "",
      co_gender: "",
      co_mobile: "",
      general_insurance_policy_number: "",
      general_insurance_provider: "",
      general_coverage_amount: "",
      life_coverage_amount: "",
      policy_type: "",
      purpose_for_seeking: "",
      life_insurance_policy_number: "",
      employment: "",
      occupation: "",
      annual_income: "",
      primary_name: "",
      primary_dob: "",
      primary_percentage: "",
      primary_relationship: "",
      secondary_name: "",
      secondary_dob: "",
      secondary_percentage: "",
      secondary_relationship: "",
      secondary_parent1: "",
      cause_of_death1: "",
      secondary_parent2: "",
      cause_of_death2: "",
      are_you_taking_medications: "",
      medication: "",
      any_bankruptcy: "",
      bankruptcy_explanation: "",
      medical_history_explanations: "",
      medical_history: "",
      bankStatement: null,
      salarySlip: null,
      incomeCertificate: null,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    setValue,
    register,
    watch,
    formState: { errors },
  } = methods;
  const email = watch("email");
  const mobile1 = watch("mobile1");
  const watchInsuranceType = watch("insurance_type");

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  useEffect(() => {
    const fetchCities = async () => {
      setLoading(true);
      setError(null);

      try {
        const citiesData = await getAllCities();
        console.log("Fetched cities data:", citiesData);
        const tamilNaduCities = citiesData
          .filter((city) => city.State_name === "Tamil Nadu")
          .sort((a, b) => a.name.localeCompare(b.name));

        setCities(tamilNaduCities);
        setLoading(true);
        const options = tamilNaduCities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setCityOptions(options);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setError("Failed to load cities data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchCities();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      setLoading(true);
      setError(null);
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setStates(availableStates);

        localStorage.setItem("statesData", JSON.stringify(availableStates));
      } catch (error) {
        console.error("Error fetching states data:", error);
        setError("Failed to load states data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchStates();
  }, []);

  const stateOptions = useMemo(
    () =>
      states.map((state) => ({
        value: state.name,
        label: state.name,
      })),
    [states]
  );

  useEffect(() => {
    const fetchPinCode = async () => {
      setLoading(true);
      setError(null);
      try {
        const pincodeData = await getAllPincode();
        const tamilNaduStates = pincodeData
          .filter((pincode) => pincode.state === "TAMIL NADU")
          .sort((a, b) => Number(a.pincode) - Number(b.pincode));
        const uniquePincodes = Array.from(
          new Set(tamilNaduStates.map((p) => p.pincode))
        );
        setPincode(uniquePincodes);
        setPincodeOptions(
          uniquePincodes.map((pincode) => ({
            value: pincode,
            label: pincode,
          }))
        );
      } catch (error) {
        console.error("Error fetching pincodes:", error);
        setError("Failed to load pincode data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getAllAdmins();
        const filteredEmployees = response.filter(
          (admin) => admin.role === "employee"
        );
        setEmployees(filteredEmployees);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getInsuranceLoanById(id);
        Object.keys(loan).forEach((key) => {
          setValue(key, loan[key]);
        });
        setInsuranceType(loan.insurance_type);
        setInitialEmail(loan.email);
        setInitialMobile(loan.mobile1);
      } catch (error) {
        console.error("Error fetching home loan data:", error);
      }
    };

    fetchLoanData();
  }, [id, setValue]);

  const checkEmail = async (email) => {
    if (email && email !== initialEmail) {
      try {
        const data = await getInsuranceLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    } else {
      setEmailExists(false);
    }
  };

  const checkMobile = async (mobile1) => {
    if (mobile1 && mobile1 !== initialMobile) {
      try {
        const data = await getInsuranceLoanByMobile(mobile1);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    } else {
      setMobileExists(false);
    }
  };

  useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  useEffect(() => {
    if (mobile1) {
      checkMobile(mobile1);
    }
  }, [mobile1]);

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  const employeeOptions = employees.map((employee) => ({
    value: `ID${employee.id} - ${employee.name}`,
    label: (
      <div className="agent-option">
        {employee.photo ? (
          <img
            src={decodeURIComponent(employee.photo)}
            alt={`${employee.name}'s avatar`}
            className="agent-image"
          />
        ) : (
          <div className="agent-image-initials">{getInitials(employee.name)}</div>
        )}
        <span className="agent-details">
          <strong>ID{employee.id}</strong> - {employee.name}
        </span>
      </div>
    ),
  }));

  const onSubmit = async (data) => {
    const formDataToSend = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formDataToSend.append(key, data[key]);
      }
    });

    try {
      await updateInsuranceLoan(id, formDataToSend);
      navigate("/insurancelist", {
        state: { successMessage: "Insurance loan updated successfully!" },
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message;

      if (typeof errorMessage === 'string') {
        if (errorMessage.includes("Email already exists")) {
          toast.error("Email already exists. Please use a different email.");
        }
        if (errorMessage.includes("Mobile number already exists")) {
          toast.error("Mobile number already exists. Please use a different mobile number.");
        }
        // In case both are mentioned in a single message
        if (errorMessage.includes("Mobile number or email already exists")) {
          toast.error("Mobile number or email already exists. Please use different details.");
        }
      } else {
        console.error("Error updating insurance loan:", error);
        toast.error("Failed to update the insurance loan. Please try again.");
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setValue(name, files[0]);
    }
  };

  const handleViewClick = async (documentType) => {
    try {
      const loan = await getInsuranceLoanById(id);
      let url = loan[documentType];

      if (url) {
        url = decodeURIComponent(url);
        window.open(url, "_blank");
      } else {
        console.warn(`No URL found for document type: ${documentType}`);
      }
    } catch (error) {
      console.error(`Error fetching ${documentType} document:`, error);
    }
  };

  const handleStepChange = async (newStep) => {
    if (newStep === 1) {
      const isValidStep0 = await methods.trigger();
      if (isValidStep0) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }
        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else if (newStep === 2) {
      const isValidStep1 = await methods.trigger();
      if (isValidStep1) {
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else {
      setActiveStep(newStep);
    }
  };
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <div>{error}</div>;
  }

  const isInsuranceTypeDisabled = Boolean(watchInsuranceType);

  return (
    <div className="edit-all-loan-container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
          <div
            className="edit-back-text"
            onClick={() => navigate("/insurancelist")}>
            &lt; Go Back
          </div>
        </div>
      )}
      <h2>Insurance</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <div className="form-row">
                  <LabeledInput
                    label="Employee ID"
                    name="created_id"
                    disabled={true}
                    style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                    registerOptions={{}}
                  />
                  <LabeledInput
                    label="Employee"
                    name="created_by"
                    disabled={true}
                    style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                    registerOptions={{}}
                  />
                </div>
                <div className="form-row">
                  {adminRole === "admin" && (
                    <LabeledSelect
                      name="assigned_to"
                      label="Assign to"
                      options={employeeOptions}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.assigned_to?.message}
                      required
                    />
                  )}
                  <LabeledDropDown
                    name="status"
                    label="Lead Status"
                    options={[
                      { value: "Open", label: "Open" },
                      { value: "In Process", label: "In Process" },
                      { value: "Pending", label: "Pending" },
                      { value: "Approved", label: "Approved" },
                      { value: "Rejected", label: "Rejected" },
                    ]}
                    registerOptions={{
                      required: "Selection is required",
                      onChange: (e) => {
                        handleStatusChange(e);
                        setValue("status", e.target.value);
                      },
                    }}
                    error={errors.status?.message}
                    required
                  />
                  {watch("status") === "Rejected" && (
                    <LabeledDropDown
                      name="rejected_reason"
                      label="Rejected Reason"
                      options={[
                        {
                          value: "CIBIL issue & more than 3 enquiries",
                          label: "CIBIL issue & more than 3 enquiries",
                        },
                        {
                          value: "Recent loan/settlement",
                          label: "Recent loan/settlement",
                        },
                        { value: "Recent DPD", label: "Recent DPD" },
                        {
                          value: "Overdue / Previous loan (HL/PL/BL/CL)",
                          label: "Overdue / Previous loan (HL/PL/BL/CL)",
                        },
                        {
                          value: "Lowest CIBIL score",
                          label: "Lowest CIBIL score",
                        },
                        {
                          value: "Guarantor CIBIL score / Co-Applicant issue",
                          label: "Guarantor CIBIL score / Co-Applicant issue",
                        },
                        {
                          value: "Pincode / Salary / Age criteria not met",
                          label: "Pincode / Salary / Age criteria not met",
                        },
                        {
                          value: "Can apply after 3 months",
                          label: "Can apply after 3 months",
                        },
                        {
                          value: "Never eligible for loan",
                          label: "Never eligible for loan",
                        },
                        {
                          value: "Credit card overdue",
                          label: "Credit card overdue",
                        },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.rejected_reason?.message}
                      required
                    />
                  )}
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Name"
                    type="text"
                    name="name"
                    registerOptions={validationRules.name}
                    error={errors.name?.message}
                    required
                  />
                  <LabeledDropDown
                    label="Gender"
                    name="gender"
                    options={[
                      { value: "Male", label: "Male" },
                      { value: "Female", label: "Female" },
                    ]}
                    registerOptions={{ required: "Gender is required" }}
                    error={errors.gender?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Date of Birth"
                    type="date"
                    name="dob"
                    registerOptions={{
                      required: "Date of Birth is required",
                      validate: (value) => {
                        const today = new Date();
                        const dob = new Date(value);
                        const age = today.getFullYear() - dob.getFullYear();
                        const monthDifference =
                          today.getMonth() - dob.getMonth();

                        // Check if the birthday hasn't occurred yet this year
                        if (
                          monthDifference < 0 ||
                          (monthDifference === 0 &&
                            today.getDate() < dob.getDate())
                        ) {
                          return (
                            age > 21 || "You must be at least 21 years old."
                          );
                        }

                        return (
                          age >= 21 || "You must be at least 21 years old."
                        );
                      },
                    }}
                    error={errors.dob?.message}
                    required
                  />
                  <LabeledInput
                    label="Age"
                    type="number"
                    name="age"
                    registerOptions={validationRules.age}
                    error={errors.age?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Phone Number (Mobile)"
                    type="tel"
                    name="mobile1"
                    registerOptions={validationRules.mobile}
                    error={errors.mobile1?.message}
                    required
                  />
                  <LabeledInput
                    label="Phone Number (Home)"
                    type="tel"
                    name="mobile2"
                    registerOptions={validationRules.mobile}
                    error={errors.mobile2?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Address Line 1"
                    type="text"
                    name="address_1"
                    registerOptions={{ required: "Address is required" }}
                    error={errors.address_1?.message}
                    required
                  />
                  <LabeledInput
                    label="Email"
                    type="text"
                    name="email"
                    registerOptions={validationRules.email}
                    error={errors.email?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledSelect
                    name="state"
                    label="State"
                    error={errors.state?.message}
                    registerOptions={{ required: "City is required" }}
                    options={stateOptions}
                    required
                  />
                  <LabeledSelect
                    label="City"
                    name="city"
                    options={cityOptions}
                    registerOptions={{ required: "City is required" }}
                    error={errors.city?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledDropDown
                    name="employee_type"
                    label="Employee Type"
                    options={[
                      { value: "salaried", label: "Salaried" },
                      { value: "self employed", label: "Self Employed" },
                    ]}
                    registerOptions={{ required: "Employee Type is required" }}
                  />
                  <LabeledSelectAgent
                    label="Pincode"
                    type="text"
                    name="pincode"
                    options={pincodeOptions}
                    registerOptions={validationRules.Pincode}
                    error={errors.pincode?.message}
                    required
                  />
                </div>

              </div>
            )}

            {activeStep === 1 && (
              <div className="section-insurance">
                <LabeledDropDown
                  label="Insurance Type"
                  name="insurance_type"
                  options={[
                    { value: "Health Insurance", label: "Health Insurance" },
                    { value: "General Insurance", label: "General Insurance" },
                    { value: "Life Insurance", label: "Life Insurance" },
                  ]}
                  registerOptions={{ required: "Selection is required" }}
                  error={errors.insurance_type?.message}
                  disabled={isInsuranceTypeDisabled}
                  {...register('insurance_type')}
                />
                {watchInsuranceType === "Health Insurance" && (
                  <div className="sections health-insurance-sections">
                    <h4>Health Insurance Loan</h4>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Patient Status"
                        name="patient_marital_status"
                        options={[
                          { value: "Single", label: "Single" },
                          { value: "Married", label: "Married" },
                          { value: "Student", label: "Student" },
                          { value: "Widow", label: "Widow" },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.patient_marital_status?.message}
                        required
                      />
                      <LabeledInput
                        label="Coverage Amount"
                        type="number"
                        name="health_insurance_coverage_amount"
                        registerOptions={{
                          required: "Coverage Amount is required",
                        }}
                        error={errors.health_insurance_coverage_amount?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledInput
                        label="Name of Co-applicant"
                        type="text"
                        name="co_name"
                        registerOptions={{
                          required: "Co-applicant name is required",
                        }}
                        error={errors.co_name?.message}
                        required
                      />

                      <LabeledInput
                        label="Date of Birth of Co-applicant"
                        type="date"
                        name="co_dob"
                        registerOptions={{
                          required: "Date of Birth is required",
                          validate: (value) => {
                            const today = new Date();
                            const dob = new Date(value);
                            const age = today.getFullYear() - dob.getFullYear();
                            const monthDifference =
                              today.getMonth() - dob.getMonth();

                            // Check if the birthday hasn't occurred yet this year
                            if (
                              monthDifference < 0 ||
                              (monthDifference === 0 &&
                                today.getDate() < dob.getDate())
                            ) {
                              return (
                                age > 21 || "You must be at least 21 years old."
                              );
                            }

                            return (
                              age >= 21 || "You must be at least 21 years old."
                            );
                          },
                        }}
                        error={errors.co_dob?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Gender of Co-applicant"
                        name="co_gender"
                        options={[
                          { value: "Male", label: "Male" },
                          { value: "Female", label: "Female" },
                        ]}
                        registerOptions={{ required: "Gender is required" }}
                        error={errors.co_gender?.message}
                        required
                      />
                      <LabeledInput
                        label="Phone Number(Mobile) of Co-applicant"
                        type="tel"
                        name="co_mobile"
                        registerOptions={validationRules.mobile}
                        error={errors.co_mobile?.message}
                        required
                      />
                    </div>
                  </div>
                )}
                {watchInsuranceType === "General Insurance" && (
                  <div className="sections general-insurance-sections">
                    <h4>General Insurance Loan</h4>
                    <div className="form-row">
                      <LabeledInput
                        label="Policy Number"
                        type="text"
                        name="general_insurance_policy_number"
                        registerOptions={{ required: "Policy Number is required" }}
                        error={errors.general_insurance_policy_number?.message}
                        required
                      />
                      <LabeledInput
                        label="Insurance Provider"
                        type="text"
                        name="general_insurance_provider"
                        registerOptions={{
                          required: "Insurance Provider is required",
                        }}
                        required
                      />
                    </div>
                    <LabeledInput
                      label="Coverage Amount"
                      type="number"
                      name="general_coverage_amount"
                      registerOptions={{ required: "Coverage Amount is required" }}
                      error={errors.general_coverage_amount?.message}
                      required
                    />
                  </div>
                )}
                {watchInsuranceType === "Life Insurance" && (
                  <div className="sections life-insurance-sections">
                    <h4>Life Insurance Loan</h4>
                    <div className="form-row">
                      <LabeledInput
                        label="Coverage Amount"
                        type="text"
                        name="life_coverage_amount"
                        registerOptions={{
                          required: "Coverage Amount is required",
                        }}
                        error={errors.life_coverage_amount?.message}
                        required
                      />
                      <LabeledDropDown
                        label="Policy Type"
                        name="policy_type"
                        options={[
                          { value: "10-year term", label: "10-year term" },
                          { value: "20-year term", label: "20-year term" },
                          { value: "30-year term", label: "30-year term" },
                          { value: "Index", label: "Index" },
                          { value: "Whole Life", label: "Whole Life" },
                          {
                            value: "Variable Universal",
                            label: "Variable Universal",
                          },
                          { value: "Universal life", label: "Universal life" },
                        ]}
                        registerOptions={{ required: "Policy Type is required" }}
                        error={errors.policy_type?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Purpose for seeking life insurance:"
                        name="purpose_for_seeking"
                        options={[
                          {
                            value: "Family Protection",
                            label: "Family Protection",
                          },
                          { value: "Debt Protection", label: "Debt Protection" },
                          { value: "Estate Planning", label: "Estate Planning" },
                          {
                            value: "Business Buy-Sell Funding",
                            label: "Business Buy-Sell Funding",
                          },
                          {
                            value: "Business Key Person Protection",
                            label: "Business Key Person Protection",
                          },
                        ]}
                        registerOptions={{ required: "Purpose is required" }}
                        error={errors.purpose_for_seeking?.message}
                        required
                      />
                      <LabeledInput
                        label="Policy Number"
                        type="text"
                        name="life_insurance_policy_number"
                        registerOptions={{ required: "Policy Number is required" }}
                        error={errors.life_insurance_policy_number?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Employment Status"
                        name="employment"
                        options={[
                          { value: "Employee", label: "Employee" },
                          { value: "Self-Employed", label: "Self-Employed" },
                          { value: "Unemployed", label: "Unemployed" },
                        ]}
                        registerOptions={{
                          required: "Employment Status is required",
                        }}
                        error={errors.employment?.message}
                        required
                      />
                      <LabeledInput
                        label="Occupation"
                        type="text"
                        name="occupation"
                        registerOptions={{ required: "Occupation is required" }}
                        error={errors.occupation?.message}
                        required
                      />
                    </div>
                    <LabeledInput
                      label="Annual Income"
                      type="number"
                      name="annual_income"
                      registerOptions={{ required: "Annual Income is required" }}
                      error={errors.annual_income?.message}
                      required
                    />
                    <h5>
                      {" "}
                      Who do you want the proceeds to go to if you were to pass
                      away?{" "}
                    </h5>
                    <h5>Primary Beneficiaries (Must add up to 100%)</h5>
                    <div className="form-row">
                      <LabeledInput
                        label="Primary Name"
                        type="text"
                        name="primary_name"
                        registerOptions={{
                          required: "Primary Beneficiary Name is required",
                        }}
                        error={errors.primary_name?.message}
                        required
                      />

                      <LabeledInput
                        label="Primary Date of Birth"
                        type="date"
                        name="primary_dob"
                        registerOptions={{
                          required: "Primary Beneficiary Date of Birth is required",
                          validate: (value) => {
                            const today = new Date();
                            const dob = new Date(value);
                            const age = today.getFullYear() - dob.getFullYear();
                            const monthDifference =
                              today.getMonth() - dob.getMonth();

                            // Check if the birthday hasn't occurred yet this year
                            if (
                              monthDifference < 0 ||
                              (monthDifference === 0 &&
                                today.getDate() < dob.getDate())
                            ) {
                              return (
                                age > 21 || "You must be at least 21 years old."
                              );
                            }

                            return (
                              age >= 21 || "You must be at least 21 years old."
                            );
                          },
                        }}
                        error={errors.primary_dob?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledInput
                        label="Primary-Relationship"
                        type="text"
                        name="primary_relationship"
                        registerOptions={{
                          required: "Primary Beneficiary Relationship is required",
                        }}
                        error={errors.primary_relationship?.message}
                        required
                      />
                      <LabeledInput
                        label="Primary-Percentage"
                        type="number"
                        name="primary_percentage"
                        registerOptions={{
                          required: "Primary Beneficiary Percentage is required",
                        }}
                        error={errors.primary_percentage?.message}
                        required
                      />
                    </div>
                    <h5>Secondary Beneficiaries (Must add up to 100%)</h5>
                    <div className="form-row">
                      <LabeledInput
                        label="Secondary-Full Name"
                        type="text"
                        name="secondary_name"
                        registerOptions={{
                          required: "Secondary Beneficiary Name is required",
                        }}
                        error={errors.secondary_name?.message}
                        required
                      />

                      <LabeledInput
                        label="Secondary Date of Birth"
                        type="date"
                        name="secondary_dob"
                        registerOptions={{
                          required:
                            "Secondary Beneficiary Date of Birth is required",
                          validate: (value) => {
                            const today = new Date();
                            const dob = new Date(value);
                            const age = today.getFullYear() - dob.getFullYear();
                            const monthDifference =
                              today.getMonth() - dob.getMonth();

                            // Check if the birthday hasn't occurred yet this year
                            if (
                              monthDifference < 0 ||
                              (monthDifference === 0 &&
                                today.getDate() < dob.getDate())
                            ) {
                              return (
                                age > 21 || "You must be at least 21 years old."
                              );
                            }

                            return (
                              age >= 21 || "You must be at least 21 years old."
                            );
                          },
                        }}
                        error={errors.secondary_dob?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledInput
                        label="Secondary-Relationship"
                        type="text"
                        name="secondary_relationship"
                        registerOptions={{
                          required:
                            "Secondary Beneficiary Relationship is required",
                        }}
                        error={errors.secondary_relationship?.message}
                        required
                      />
                      <LabeledInput
                        label="Secondary-Percentage"
                        type="number"
                        name="secondary_percentage"
                        registerOptions={{
                          required: "Secondary Beneficiary Percentage is required",
                        }}
                        error={errors.secondary_percentage?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Parent 1"
                        name="secondary_parent1"
                        options={[
                          { value: "Living", label: "Living" },
                          { value: "Deceased", label: "Deceased" },
                        ]}
                        registerOptions={{
                          required: "Secondary Parent 1 is required",
                        }}
                        error={errors.secondary_parent1?.message}
                        required
                      />
                      <LabeledInput
                        label="Cause of death?  If so at what age?"
                        type="text"
                        name="cause_of_death1"
                        registerOptions={{
                          required: "Cause of Death 1 is required",
                        }}
                        error={errors.cause_of_death1?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Parent 2"
                        name="secondary_parent2"
                        options={[
                          { value: "Living", label: "Living" },
                          { value: "Deceased", label: "Deceased" },
                        ]}
                        registerOptions={{
                          required: "Secondary Parent 2 is required",
                        }}
                        error={errors.secondary_parent2?.message}
                        required
                      />
                      <LabeledInput
                        label="Cause of death?  If so at what age?"
                        type="text"
                        name="cause_of_death2"
                        registerOptions={{
                          required: "Cause of Death 2 is required",
                        }}
                        error={errors.cause_of_death2?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Are you taking any medications"
                        name="are_you_taking_medications"
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.are_you_taking_medications?.message}
                        required
                      />
                      <LabeledInput
                        label="Medications and dosage"
                        type="text"
                        name="medication"
                        registerOptions={{
                          required: "Medication Details are required",
                        }}
                        error={errors.medication?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Any bankruptcy?"
                        name="any_bankruptcy"
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.any_bankruptcy?.message}
                        required
                      />
                      <LabeledInput
                        label="Bankruptcy Explanation"
                        type="text"
                        name="bankruptcy_explanation"
                        registerOptions={{ required: "Explanation is required" }}
                        error={errors.bankruptcy_explanation?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledDropDown
                        label="Medical history:  Have you ever been told you had, or been treated for any of the following conditions? Only check if yes."
                        name="medical_history"
                        options={[
                          { value: "Alcohol Abuse", label: "Alcohol Abuse" },
                          { value: "Alzheimer's", label: "Alzheimer's" },
                          { value: "Asthma", label: "Asthma" },
                          { value: "Cancer", label: "Cancer" },
                          { value: "Diabetes", label: "Diabetes" },
                          { value: "Drug Abuse", label: "Drug Abuse" },
                          { value: "Kidney Disease", label: "Kidney Disease" },
                          { value: "Lupus", label: "Lupus" },
                          { value: "Stroke/TIA", label: "Stroke/TIA" },
                          {
                            value: "Neck, Back, Spine Injury",
                            label: "Neck, Back, Spine Injury",
                          },
                          { value: "Other", label: "Other" },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.medical_history?.message}
                        required
                      />
                    </div>
                    <div className="form-row">
                      <LabeledInput
                        label="Medical History Explanations"
                        type="text"
                        name="medical_history_explanations"
                        registerOptions={{
                          required: "Medical History Explanations are required",
                        }}
                        error={errors.medical_history_explanations?.message}
                        required
                      />
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group">
                      <label htmlFor="pan" className="document-label">
                        Bank Statement
                      </label>
                      <div className="document-file-container">
                        <input
                          label="bankStatement"
                          type="file"
                          name="bankStatement"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("bankStatement")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="pan" className="document-label">
                        SalarySlip
                      </label>
                      <div className="document-label-container">
                        <input
                          label="salarySlip"
                          type="file"
                          name="salarySlip"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("salarySlip")}
                      >
                        View
                      </button>
                    </div>
                    <div className="form-row">
                      <div className="document-upload-group">
                        <label htmlFor="pan" className="document-label">
                          Income Certificate
                        </label>
                        <div className="document-file-container">
                          <input
                            label="incomeCertificate"
                            type="file"
                            name="incomeCertificate"
                            onChange={handleFileChange}
                            className="form-control-file"
                          />
                        </div>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("incomeCertificate")}
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="success"
                    className="custom-submit-button"
                  >
                    Update
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default EditInsuranceLoan;
